import CharlesButton from "components/base/Button";

const ContainerView = ({ pkg, container, updatePkg, createContainer }) => {
  function deleteContainer() {
    updatePkg({
      containers: pkg.containers.filter((c) => c.id !== container.id),
    });
  }

  const children =
    pkg.containers?.filter((c) => c.parentId === container.id) || [];

  return (
    <div className="border dark:border-gray-700 p-4 rounded-xl">
      <div className="flex justify-between items-center">
        <h5>{container.name}</h5>
        <CharlesButton danger onClick={deleteContainer}>
          Delete
        </CharlesButton>
      </div>

      <div className="text-xs">
        <div>
          <label htmlFor="">Size: </label>
          <span>{container.size}</span>
        </div>
        <div>
          <label htmlFor="">Qty: </label>
          <span>{container.qty}</span>
        </div>
      </div>

      {children.length > 0 && (
        <div className="space-y-4 mt-4">
          {children.map((child) => (
            <ContainerView
              key={child.id}
              container={child}
              pkg={pkg}
              updatePkg={updatePkg}
              createContainer={createContainer}
            />
          ))}
        </div>
      )}

      <div className="mt-2 flex justify-between">
        <CharlesButton onClick={() => createContainer(container.id)}>
          + Container
        </CharlesButton>
      </div>
    </div>
  );
};

export default ContainerView;
